<template>
  <div>
    <div class="modal fade" id="edit_sub_sub_category" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit Helper Sub Category</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="row px-3">
                <label class="col-lg-4 pl-0 m-0 d-flex">Name</label>
                <div class="col-lg-8 p-0 m-0 d-flex">
                  <input class="form-control" v-model="name">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row px-3">
                <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex">Job Price</label>
                <div class="col-lg-8 p-0 m-0 d-flex">
                  <input class="form-control" v-model="admin_fee">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="submit()">Submit</button>
            <button data-dismiss="modal" class="btn btn-danger">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['edit_name', 'edit_admin_fee'],
  data(){
    return{
      admin_fee: 0,
      name: '',
    }
  },
  watch:{
    admin_fee(val){
      this.admin_fee = val != '' ? parseFloat(val.replace(/\./g,'')).toLocaleString('id-ID') : '0'
    },
    edit_name(val){
      this.name = val
    },
    edit_admin_fee(val){
      this.admin_fee = val
    },
  },
  methods:{
    submit(){
      var data = {
        name: this.name,
        admin_fee: this.admin_fee,
      }
      $('#edit_sub_sub_category').modal('hide')
      this.$emit('on-submit',data)
    }
  }
}
</script>
